export default __webpack_public_path__ + "static/media/Be_a_pong.29034755.jpg";